import { useCallback, useMemo } from 'react';
import { detectNumericColumnSelections, validateSheetData } from './utils';
const PREFIX = 'common: components: Editor: hooks: useSelectionsEditing:';
export default function useAutoSelectionsUpdate(_ref) {
  let {
    workbookData,
    columnStructure
  } = _ref;
  // Validate the active sheet data
  const activeSheetDataValidationResult = useMemo(() => {
    var _columnStructure$subC;

    // Get the number of columns per group
    const columnsPerGroup = (columnStructure === null || columnStructure === void 0 ? void 0 : columnStructure.minRequiredColumns) ?? (columnStructure === null || columnStructure === void 0 ? void 0 : (_columnStructure$subC = columnStructure.subColumns) === null || _columnStructure$subC === void 0 ? void 0 : _columnStructure$subC.length) ?? 1;
    return validateSheetData((workbookData || [])[0], columnsPerGroup, columnStructure === null || columnStructure === void 0 ? void 0 : columnStructure.skipHeaderRows);
  }, [workbookData, columnStructure]); // Updates section configuration with detected numeric column selections

  const onAutoSelectionsUpdate = useCallback((submit, targetSection, workbook) => {
    var _columnStructure$subC2;

    if (!targetSection.id) {
      throw Error(`${PREFIX} missing section id, unable to update selections`);
    } // Get the number of columns per group


    const columnsPerGroup = (columnStructure === null || columnStructure === void 0 ? void 0 : (_columnStructure$subC2 = columnStructure.subColumns) === null || _columnStructure$subC2 === void 0 ? void 0 : _columnStructure$subC2.length) ?? 1; // Detect column selections containing numeric values

    const changedSelections = detectNumericColumnSelections(workbook[0], columnsPerGroup);
    if (!(changedSelections !== null && changedSelections !== void 0 && changedSelections.length)) return; // Update section config with new selections

    submit(`sections.${targetSection.id}.config`, {
      selections: changedSelections.join('|')
    });
  }, [columnStructure]);
  return {
    activeSheetDataValidationResult,
    onAutoSelectionsUpdate
  };
}